import React from 'react';
import LogTable from 'components/atoms/log-table';
import useUpdateEffect from 'infrastructure/hooks/utils/use-update-effect';
import { useInteractiveStatusLog } from 'infrastructure/hooks/logs/use-interactive-status-log';

import type { PlatformEnums } from 'infrastructure/enums';

interface IProps {
  patientGuid: string;
  dateRange?: [Date, Date];
  module: PlatformEnums.RPM | PlatformEnums.CCM;
}

const PatientInteractiveStatusLog: React.FC<IProps> = (props) => {
  const { patientGuid, dateRange, module } = props;

  const { loading, items, meta, setMeta } = useInteractiveStatusLog({
    patientGuid,
    meta: {
      dateRange,
      module,
    },
  });

  const onChangePage = (page: number) => {
    setMeta({
      ...meta,
      page,
      dateRange,
    });
  };

  useUpdateEffect(() => {
    setMeta({
      ...meta,
      page: 1,
      dateRange,
      module,
    });
  }, [dateRange, module]);

  return (
    <LogTable
      dataCy="patient-interactive-status-log-table"
      items={items}
      loading={loading}
      pagination={{
        current: meta.page,
        pageSize: meta.items,
        total: meta.totalCount,
        position: ['bottomCenter'],
      }}
      onChangePage={onChangePage}
    />
  );
};

export default PatientInteractiveStatusLog;
